import { Info } from "luxon"

const PROFILE_HOURS = 24

export const HOUR_COLUMNS = Array.from(
  { length: PROFILE_HOURS },
  (_, hour) => hour
)

const dayHasValues = (dayAverages: (number | null)[]): boolean =>
  dayAverages.some((value) => value != null)

const averageNonNullValues = (values: (number | null)[]): number | null => {
  const nonNullValues = values.filter((value): value is number => value != null)
  if (nonNullValues.length === 0) {
    return null
  }

  const sum = nonNullValues.reduce(
    (runningTotal, currentValue) => runningTotal + currentValue,
    0
  )
  return sum / nonNullValues.length
}

export const getSundayFirstWeekdays = (locale: string): string[] => {
  const mondayFirst = Info.weekdays("long", { locale })
  return [mondayFirst[6], ...mondayFirst.slice(0, 6)]
}

interface HourlyProfileMatrixDay {
  dayAverages: (number | null)[]
  dayIndex: number
  rowTotal: number | null
}

export const getHourlyProfileMatrix = (
  averages: (number | null)[][],
  startWeekday = 0
) => {
  const visibleDays: HourlyProfileMatrixDay[] = Array.from(
    { length: averages.length },
    (_, offset) => (startWeekday + offset) % averages.length
  ).flatMap((dayIndex) => {
    const dayAverages = averages[dayIndex]

    return dayHasValues(dayAverages)
      ? [
          {
            dayAverages,
            dayIndex,
            rowTotal: averageNonNullValues(dayAverages),
          },
        ]
      : []
  })
  const columnTotals = HOUR_COLUMNS.map((hour) =>
    averageNonNullValues(visibleDays.map((day) => day.dayAverages[hour]))
  )
  const hourlyValues = visibleDays
    .flatMap((day) => day.dayAverages)
    .filter((value): value is number => value != null)

  return {
    columnTotals,
    grandTotal: averageNonNullValues(hourlyValues),
    valueRange:
      hourlyValues.length === 0
        ? undefined
        : {
            max: Math.max(...hourlyValues),
            min: Math.min(...hourlyValues),
          },
    visibleDays,
  }
}
